<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <b-tabs pills justified nav-class="bg-light" content-class="p-3 text-muted mx-4">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">User Roles</span>
            </template>
            <user-roles-component/>
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Permissions</span>
            </template>
            <permission-component/>
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Customer Types</span>
            </template>
            <customer-type-component/>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Customer Tiers</span>
            </template>
            <customer-tier-component/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import CustomerTypeComponent from "@/components/settings/customer-type-component";
import CustomerTierComponent from "@/components/settings/customer-tier-component";
import PermissionComponent from "@/components/settings/permission-component";
import UserRolesComponent from "@/components/roles/user-roles-component";

export default {
  page: {
    title: "User Settings",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    UserRolesComponent,
    PermissionComponent,
    CustomerTierComponent,
    CustomerTypeComponent, PageHeader, Layout},
  name: "user-settings",
  data() {
    return {
      title: "User Settings",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "User Settings",
          active: true
        }
      ],
    }
  },

}
</script>

<style scoped>

</style>
